import { lazy } from "react";
import { Navigate } from "react-router-dom";

const CommonLayout = lazy(() => import("../layouts/CommonLayout.jsx"));

const ShopHomeView = lazy(() => import("../views/home/ShopHomeView.jsx"));
const ItemHomeView = lazy(() => import("../views/item/ItemHomeView.jsx"));
const CartHomeView = lazy(() => import("../views/cart/CartHomeView.jsx"));
const WishListHomeView = lazy(() => import("../views/wishList/WishListHomeView.jsx"));
const CheckoutHomeView = lazy(() => import("../views/checkout/CheckoutHomeView.jsx"));

const PaymentResultView = lazy(() => import("../views/payment/PaymentResultView.jsx"));
const PaymentSuccessView = lazy(() => import("../views/payment/PaymentSuccessView.jsx"));

const OrderHomeView = lazy(() => import("../views/order/OrderHomeView.jsx"));
const OrderDetailHomeView  = lazy(() => import("../views/order/detail/OrderDetailHomeView.jsx"));

const InvoiceHomeView =  lazy(() => import("../views/invoice/InvoiceHomeView.jsx"));

const AccountHomeView =  lazy(() => import("../views/account/AccountHomeView.jsx"));
const AddressViewHome =  lazy(() => import("../views/account/address/AddressViewHome.jsx"));

const ContactUsHomeView  =  lazy(() => import("../views/account/contactUs/ContactUsHomeView.jsx"));

const AboutUsHomeView =  lazy(() => import("../views/aboutUs/AboutUsHomeView.jsx"));

const SecurityHomeView  =  lazy(() => import("../views/account/security/SecurityHomeView.jsx"));

const PageNotFoundView =  lazy(() => import("../views/common/PageNotFoundView.jsx"));

const ThemeRoutes = [
    {
        path: "/",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <ShopHomeView /> },
            { path: "/itm/*", exact: true, element: <ItemHomeView /> },
            { path: "/cart", exact: true, element: <CartHomeView /> },
            { path: "/wishlist", exact: true, element: <WishListHomeView /> },
            { path: "/checkout", exact: true, element: <CheckoutHomeView /> },
        ],
    },
    {
        path: "/payment",
        element: <CommonLayout />,
        children: [
            { path: "result", exact: true, element: <PaymentResultView /> },
            { path: "done", exact: true, element: <PaymentSuccessView /> },
        ]
    },
    {
        path: "/order",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <OrderHomeView /> },
            { path: "/order/*", exact: true, element: <OrderDetailHomeView /> },
        ]
    },
    {
        path: "/invoice",
        element: <CommonLayout />,
        children: [
            { path: "/invoice/*", exact: true, element: <InvoiceHomeView /> },
        ]
    },

    {
        path: "/account",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <AccountHomeView /> },
            { path: "address", exact: true, element: <AddressViewHome /> },
        ]
    },

    {
        path: "/contact-us",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <ContactUsHomeView /> },
        ]
    },

    {
        path: "/about-us",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <AboutUsHomeView /> },
        ]
    },

    {
        path: "/security",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <SecurityHomeView /> },
        ]
    },

    {
        path: "*",
        element: <Navigate to="/error/not-found" replace />,
    },

    {
        path: "/error",
        element: <CommonLayout />,
        children: [
            { path: "not-found", exact: true, element: <PageNotFoundView /> },
        ]
    },


    

    
]
export default ThemeRoutes;